import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ElementPlus from "element-plus";
import "element-plus/dist/index.css";
import * as ElementPlusIconsVue from "@element-plus/icons-vue";
import "./assets/fonts.css";

var app = createApp(App);
app.use(store);

// Call the action once during app initialization
// app.mixin({
//   created() {
//   },
// });

const djport = process.env.VUE_APP_DJANGO_PORT
  ? ":" + process.env.VUE_APP_DJANGO_PORT
  : "";

app.config.globalProperties.$djport = djport;
store.dispatch("initializeApp");
app.use(router);
app.use(ElementPlus);
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component);
}
app.mount("#app");

export default app;
